module.exports = "<svg width=\"63px\" height=\"63px\" viewBox=\"0 0 63 63\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>Align Vertically</title>\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#525151\" d=\"M0 0h63v63H0z\"/>\n    <g transform=\"translate(17 22)\" fill=\"#FFF\">\n      <rect x=\"6\" width=\"7\" height=\"19\" rx=\"1\"/>\n      <rect x=\"16\" y=\"4\" width=\"7\" height=\"11.881\" rx=\"1\"/>\n      <rect y=\"9\" width=\"28.309\" height=\"1.718\" rx=\".859\"/>\n    </g>\n  </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/align/align-vert.svg
// module id = 831
// module chunks = 0